import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/suspensiones-de-pagos-empleados-documentos';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Suspensiones de Pagos Documentos
 * @param {object} params
 * @returns {Promiser<object[]>}
 */
export const getSuspensionesDePagosDocumentos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Suspension de Pago Documentos
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSuspensionDePagoDocumento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Suspension de Pago Documentos
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSuspensionDePagoDocumento = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Suspension de Pago Documentos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSuspensionDePagoDocumento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Suspension de Pago Documentos
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteSuspensionDePagoDocumento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Elimiando correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
